//Import STORE
import { connect } from "react-redux";
import {
  action_setBetValue,
  action_setCurrentTicket,
  action_setGameplayData,
  action_setNextDraws,
} from "../../../_core/store/actions/actions.Game";
import { store } from "../../../_core/core.Store";

//Import CORE
import {
  __Currency,
  __CurrentConnection,
  __EventDispatcher,
  __Lang,
  __ProxiProvider,
  __UrlParams,
} from "../../../_core/core";
import { EventClass, EventType } from "../../config/Events";

//Import CONFIG
import {
  ALLOWED_NUMBERS,
  BETTING_OPEN_SECONDS,
  MENU_POPUPS,
  NO_OF_DRAWS,
} from "../../config/Game";

//Import COMPONENTS
import BetTicket from "./Bet.ticketPreview";
import BetOption from "./Bet.option";
import { useEffect, useState } from "react";
import { setStatusData } from "../../../_core/store/slices/slice.Game";

const Bet = (_props?: any) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [ticketStake, setTicketStake] = useState<number>(
    _props.SESSION_DATA.betLevels[_props.SESSION_DATA.betIndex]
  );
  const [placeBetClasses, setPlaceBetClasses] = useState<string[]>([]);
  const [userCanBet, setUserCanBet] = useState<boolean>(true);

  const changeStake = (nValue: number) => {
    __ProxiProvider.updateStake(nValue);
    action_setBetValue(nValue)(store.dispatch);
  };

  const changeNextDraws = (nValue: number) => {
    action_setNextDraws(nValue)(store.dispatch);
  };

  const calculateTotal = () => {
    let _total = 0;
    let noTickets = Object.entries(_props.GAMEPLAY.selectedNumbers).length
      ? 1
      : 0;
    let nextDraws = _props.GAMEPLAY.nextDraws;

    _total = noTickets * _props.STATUS_DATA.bet * nextDraws;

    return _total;
  };

  //@todo - add game status
  const canBet = (): boolean => {
    if (
      !_props.GAMEPLAY.bettingOpen ||
      _props.GAMEPLAY.timer <= BETTING_OPEN_SECONDS
    )
      return true;

    let _selectedNumbers = Object.values(
      _props.GAMEPLAY.selectedNumbers
    ).filter((item: any) => {
      return item.isSelected === true;
    });
    if (_selectedNumbers.length === 0) return true;

    if (!ALLOWED_NUMBERS.includes(_selectedNumbers.length)) return true;

    if (_props.GAMEPLAY.roundStart === true) return true;

    return false;
  };

  const isInsufficientFunds = () => {
    let _total = calculateTotal();

    if (_props.USER_DATA.credit < _total) {
      // show INSUFFICIENT FUNDS popup
      if (_props.USER_DATA.credit === 0) {
        __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
          type: MENU_POPUPS.ZERO_FUNDS_WINDOW,
        });
      } else {
        __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
          type: MENU_POPUPS.INSUFFICIENT_FUNDS_WINDOW,
        });
      }
      __ProxiProvider.insufficientFunds();
      return true;
    } else {
      return false;
    }
  };

  const newTicket = () => {
    action_setCurrentTicket(null)(store.dispatch);
  };

  const placeBet = () => {
    if (!canBet) return false;
    //@todo check if user has balance
    if (isInsufficientFunds()) return false;

    const _store = store.getState();

    let _selectedNumbers = Object.entries(_store.game.GAMEPLAY.selectedNumbers)
      // eslint-disable-next-line array-callback-return
      .map((item: any, k: any) => {
        if (item[1].isSelected === true) return item[0];
      })
      .filter((item: any) => item !== undefined);

    //proxi call
    __ProxiProvider.roundStart(_props.STATUS_DATA.bet, _props.USER_DATA.credit);

    //place bet to RGS
    __CurrentConnection.placeBet(_selectedNumbers);

    //send to store that round starts
    store.dispatch(
      action_setGameplayData({
        roundStart: true,
      })
    );

    //set subscriptions
    if (_store.game.GAMEPLAY.nextDraws > 1) {
      __CurrentConnection.subscription(
        _selectedNumbers,
        _store.game.GAMEPLAY.nextDraws - 1
      );
    }

    //get confirmed numbers
    __CurrentConnection.getBets();
  };

  const getPlaceButtonClasses = (_currentTicket: any) => {
    let _classes = ["btn-primary-new"];
    if (_currentTicket) _classes.push("ticket-placed");

    setPlaceBetClasses(_classes);
  };

  const isRegisterMode = () => {
    let siteID = parseInt(__UrlParams.props.siteID);
    let funReal = __UrlParams.props.isFun;

    if (siteID === 30 && funReal === -1) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (_props.GAMEPLAY.currentTicket) {
      setIsDisabled(true);
      setTicketStake(_props.GAMEPLAY.currentTicket.stake);
      getPlaceButtonClasses(true);
    } else {
      const _store = store.getState();

      setIsDisabled(false);
      setTicketStake(0);
      getPlaceButtonClasses(false);
      store.dispatch(
        setStatusData({
          bet: ticketStake
            ? ticketStake
            : _store.game.SESSION_DATA.betLevels[
                _store.game.SESSION_DATA.betIndex
              ],
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.GAMEPLAY.currentTicket]);

  useEffect(() => {
    if (_props.GAMEPLAY.drawStart) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [_props.GAMEPLAY.drawStart]);

  useEffect(() => {
    setUserCanBet(canBet());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    _props.GAMEPLAY.timer,
    _props.GAMEPLAY.bettingOpen,
    _props.GAMEPLAY.selectedNumbers,
    _props.GAMEPLAY.roundStart,
    _props.GAMEPLAY.currentTicket,
  ]);

  useEffect(() => {
    getPlaceButtonClasses(false);
  }, []);

  return (
    <div className="gameplay-container">
      <div className="bet-container">
        <BetTicket />
        <div className="game-options-container">
          <BetOption
            isMoney={false}
            options={NO_OF_DRAWS}
            title={__Lang.translate("n:play.draw")}
            onChange={changeNextDraws}
            isDisabled={isDisabled}
            selectedOption={0}
            defaultOption={NO_OF_DRAWS.indexOf(_props.GAMEPLAY.nextDraws)}
          />
          <BetOption
            isMoney={true}
            options={_props.SESSION_DATA.betLevels as any}
            title={__Lang.translate("n:play.stake")}
            onChange={changeStake}
            isDisabled={isDisabled}
            selectedOption={ticketStake}
            defaultOption={_props.SESSION_DATA.betLevels.indexOf(
              _props.STATUS_DATA.bet
            )}
          />
        </div>
        <div className="ticket-purchase-options-container-container">
          {placeBetClasses.includes("ticket-placed") ? (
            <button
              type="submit"
              className={placeBetClasses.join(" ")}
              onClick={() => newTicket()}
              disabled={_props.GAMEPLAY.drawStart || _props.GAMEPLAY.timer <= 0}
            >
              <span className="plusSymbol">+</span>
              <span>{__Lang.translate("n:play.addAnother")}</span>
            </button>
          ) : (
            <button
              type="submit"
              className={placeBetClasses.join(" ")}
              disabled={userCanBet}
              onClick={() => placeBet()}
            >
              <span>
                {isRegisterMode()
                  ? __Lang.translate("n:REGISTER_TO_PLAY")
                  : __Lang.translate("n:play.play") +
                    " " +
                    __Currency.format(calculateTotal())}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GUI_DATA: state.game.GUI_DATA,
    GAMEPLAY: state.game.GAMEPLAY,
    SESSION_DATA: state.game.SESSION_DATA,
    STATUS_DATA: state.game.STATUS_DATA,
    USER_DATA: state.game.USER_DATA,
  };
};

export default connect(mapStateToProps, {})(Bet);
